"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_click_listener_for_attr_1 = __importDefault(require("../../utils/add-click-listener-for-attr"));
var variables_scss_1 = require("../../../styles/plugins/drawer/variables.scss");
var closingTimeout = parseFloat(variables_scss_1.closeTransitionDuration.replace('s', '')) * 1000;
var dimEl = document.createElement('div');
dimEl.className = 'drawer-dim';
var close = function (id) {
    var el = document.getElementById(id);
    if (el) {
        el.classList.add('closing');
        el.classList.remove('open');
        dimEl.classList.remove('dark');
        setTimeout(function () {
            el.classList.remove('closing');
            dimEl.remove();
        }, closingTimeout);
    }
};
var open = function (id) {
    var el = document.getElementById(id);
    if (el) {
        el.classList.add('open');
        document.body.appendChild(dimEl);
        setTimeout(function () { return dimEl.classList.add('dark'); }, 1);
        dimEl.onclick = function () { return close(id); };
    }
};
(0, add_click_listener_for_attr_1.default)('data-close-drawer', close);
(0, add_click_listener_for_attr_1.default)('data-open-drawer', open);
window.Drawer = {
    close: close,
    open: open,
};
